// @flow

import { completeRequest, beginRequest } from "@store/utils";
import type { DynamicQuestionsState } from "./types";
import type { Action } from "redux-action";
import type { ApprovableContainer } from "@modules/service/types";
import type { DynamicQuestionContent } from "@modules/service/reducer/dynamic-questions/types";

export type ShowDynamicQuestionModalRequest = $Exact<{
  show: boolean,
  step?: number,
}>;

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

export const onAddNewDynamicQuestion = (state: DynamicQuestionsState) => () => startRequest(state);
export const onAddNewDynamicQuestionSuccess = (state: DynamicQuestionsState) => () =>
  finishRequest(state);
export const onAddNewDynamicQuestionError = (state: DynamicQuestionsState) => () =>
  finishRequest(state);

export const onUpdateDynamicQuestion = (state: DynamicQuestionsState) => () => startRequest(state);
export const onUpdateDynamicQuestionSuccess = (state: DynamicQuestionsState) => () =>
  finishRequest(state);
export const onUpdateDynamicQuestionError = (state: DynamicQuestionsState) => () =>
  finishRequest(state);

export const onGetDynamicQuestions = (state: DynamicQuestionsState) => () => startRequest(state);

export const onGetDynamicQuestionsSuccess = (state: DynamicQuestionsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  list: payload,
});

export const onGetDynamicQuestionsError = (state: DynamicQuestionsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onNewDynamicQuestion = (state: DynamicQuestionsState) => (action: Action<void>) => ({
  ...state,
  draft: {
    questionText: null,
    questionType: null,
  },
});

export const onSetShowAddDynamicQuestionModal = (state: DynamicQuestionsState) => ({
  payload,
}: Action<ShowDynamicQuestionModalRequest>) => {
  if (!payload) {
    return state;
  }

  return {
    ...state,
    modals: {
      ...state.modals,
      showAddDynamicQuestionModal: payload.show,
      modalStep: payload.step || state.modals.modalStep,
    },
  };
};

export const onUpdateDynamicQuestionDraft = (state: DynamicQuestionsState) => ({
  payload,
}: Object) => ({
  ...state,
  draft: payload,
});

export const onSetDynamicQuestionRevisionSchema = (state: DynamicQuestionsState) => ({
  payload,
}: Object) => ({
  ...state,
  error: null,
  schema: payload,
});

export const onSetDynamicQuestionAssignments = (state: DynamicQuestionsState) => ({
  payload,
}: Object) => ({
  ...state,
  assignments: payload,
});

export const onSetDynamicQuestionDraftAssignments = (state: DynamicQuestionsState) => ({
  payload,
}: Object) => ({
  ...state,
  draftAssignments: payload,
});

export const onGetDynamicQuestion = (state: DynamicQuestionsState) => () => startRequest(state);

export const onGetDynamicQuestionSuccess = (state: DynamicQuestionsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  current: payload,
});

export const onGetDynamicQuestionError = (state: DynamicQuestionsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onShowDynamicQuestionEditModal = (state: DynamicQuestionsState) => ({
  payload,
}: Action<ShowDynamicQuestionModalRequest>) => {
  if (!payload) {
    return state;
  }

  return {
    ...state,
    modals: {
      ...state.modals,
      showEditModal: payload.show,
      modalStep: payload.step || state.modals.modalStep,
    },
  };
};

export const onUpdateDynamicQuestionAssignmentsError = (state: DynamicQuestionsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onShowEditDynamicQuestionAssignmentsModal = (state: DynamicQuestionsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditAssignmentsModal: payload,
  },
});
